module.exports = __webpack_public_path__ + "static/client22-b9e3abc4b2da1a7c927b433772f8cc37.png";